'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$EnvelopeId$() {
  this.c6s = null;
  this.c6t = false;
  this.c6q = null;
  this.c6r = false;
}
export { $c_Lpresto_types$EnvelopeId$ as $c_Lpresto_types$EnvelopeId$ };
$p = $c_Lpresto_types$EnvelopeId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$EnvelopeId$;
/** @constructor */
function $h_Lpresto_types$EnvelopeId$() {
}
export { $h_Lpresto_types$EnvelopeId$ as $h_Lpresto_types$EnvelopeId$ };
$h_Lpresto_types$EnvelopeId$.prototype = $p;
$p.cI1 = (function() {
  if ((!this.c6t)) {
    this.c6s = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.c6t = true;
  }
  return this.c6s;
});
$p.v8 = (function() {
  if ((!this.c6r)) {
    this.c6q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c6r = true;
  }
  return this.c6q;
});
var $d_Lpresto_types$EnvelopeId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$EnvelopeId$, "presto.types$EnvelopeId$", ({
  ZV: 1,
  D: 1
}));
export { $d_Lpresto_types$EnvelopeId$ as $d_Lpresto_types$EnvelopeId$ };
var $n_Lpresto_types$EnvelopeId$;
function $m_Lpresto_types$EnvelopeId$() {
  if ((!$n_Lpresto_types$EnvelopeId$)) {
    $n_Lpresto_types$EnvelopeId$ = new $c_Lpresto_types$EnvelopeId$();
  }
  return $n_Lpresto_types$EnvelopeId$;
}
export { $m_Lpresto_types$EnvelopeId$ as $m_Lpresto_types$EnvelopeId$ };
//# sourceMappingURL=presto.types$-Envelope-Id$.js.map
